import { Modal } from 'components';
import styled from 'styled-components';

export const AcknowledgmentModal = styled(Modal).attrs({
  width: 'max(500px, 60vw)',
})``;
